export default __webpack_public_path__ + "static/media/0xf04adbf75cdfc5ed26eea4bbbb991db002036bdd.890e1af0.svg";